import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const PencilBoxIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="pencilBox" ref={ref} {...props}>
      <path d="M20.6,3.37a3.17,3.17,0,0,0-4.49,0L7.52,12a.75.75,0,0,0-.22.53v3.44a.75.75,0,0,0,.46.69.64.64,0,0,0,.28.06h3.44a.75.75,0,0,0,.53-.22l7.56-7.56,0,0,.05-.06.94-.94A3.17,3.17,0,0,0,20.6,3.37ZM17.17,4.43A1.68,1.68,0,0,1,19.54,6.8l-.47.47L16.7,4.9Zm-6,10.74H8.8V12.8L15.64,6,18,8.33Zm6.07,5.58H7.06A3.81,3.81,0,0,1,3.25,17V6.76A3.82,3.82,0,0,1,7.06,3h5.09a.75.75,0,0,1,0,1.5H7.06A2.31,2.31,0,0,0,4.75,6.76V17a2.3,2.3,0,0,0,2.31,2.3H17.24A2.31,2.31,0,0,0,19.55,17v-5.1a.75.75,0,1,1,1.5,0V17A3.81,3.81,0,0,1,17.24,20.75Z" />
    </Icon>
  ),
) as IconWithRender;

PencilBoxIcon.displayName = 'PencilBoxIcon';
PencilBoxIcon.renderIcon = (props) => <PencilBoxIcon {...props} />;
export default PencilBoxIcon;
